import React, { useState, useCallback, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { debounce } from "lodash";

import { Link } from "react-router-dom";
import { Button, DataTable } from "../Components";
import { getAxios } from "../Services/commonService";
import { API_ADD_MATCH } from "../utils/api/ApiConstant";
import { dateFormat } from "../helper/common";

const GlobalSearchModal = ({ handleShowHide }) => {
  const [searchTerm, setSearchTerm] = useState("");

  // Debounced version of handleChange
  const handleChange = useCallback(
    debounce((e) => {
      setSearchTerm(e.target.value);
    }, 500),
    []
  );

  const { isLoading, data: globalApiData } = useQuery({
    queryKey: ["globalApiData", searchTerm],
    queryFn: async () =>
      await getAxios(API_ADD_MATCH, {
        search: searchTerm,
      }),
    enabled: !!searchTerm,
  });

  const fetchData = useCallback(() => {
    if (!globalApiData) return { data: [], pages: 0 };

    return {
      data: globalApiData.docs,
      pages: globalApiData.pages || 0,
    };
  }, [globalApiData]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "name",
        header: "Match Name",
        cell: ({ getValue, row }) => (
          <Link
            to={`/eventmaster/market/${row?.original?.id}`}
            onClick={() => handleShowHide()}
          >
            {getValue()}
          </Link>
        ),
      },
      {
        accessorKey: "openDate",
        header: "openDate",
        cell: ({ row }) =>
          dateFormat(row?.original?.openDate).formattedDateTime,
      },
    ],
    []
  );

  return (
    <>
      <div className="card">
        <input
          type="text"
          className="form-control top-search mb-0"
          name="search"
          id="search"
          placeholder="Search..."
          onChange={handleChange}
        />
        <Button className="iconoir-search search_font" icon="FaSearch" />
      </div>

      <div className="row  ">
        <div className="col-lg-12 ">
          <div className="card">
            <DataTable
              columns={columns}
              fetchData={fetchData}
              isSearchable={false}
              isPagination={false}
              isPageSize={false}
              isLoading={isLoading}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default GlobalSearchModal;
